import axios from 'axios'
import Auth from '@/classes/Auth';
import {toast} from 'vue3-toastify';

export default class Http {
    static post(url, content, params) {
        let boundary = Math.random().toString().substr(2);
        let headers = {'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundary' + boundary};

        headers[Auth.TOKEN_VAR] = Auth.token();
        headers['boundary'] = Math.random().toString().substr(2);

        if(content === null) {
            content = {}
        }

        return new Promise((resolve, reject) => {
            axios.post(url, {...content, 'datafilter' : params}, {
                headers: headers
            }).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                if (error.name !== "CanceledError") {
                    if (typeof reject === 'function') {
                        reject(error);
                    }
                }
            });
        });
    }

    static file(url, content, params) {
        let boundary = Math.random().toString().substr(2);
        let headers = {'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundary' + boundary};

        headers[Auth.TOKEN_VAR] = Auth.token();
        headers['datafilter'] = JSON.stringify(params);
        headers['boundary'] = Math.random().toString().substr(2);
        ;

        return new Promise((resolve, reject) => {
            axios.post(url, content, {
                headers: headers,
                responseType: 'arraybuffer'
            }).then((response) => {
                resolve(response);
            }).catch((error) => {
                if (typeof reject === 'function') {
                    reject(error);
                }
            });
        });
    }

    static showError(error) {
        console.log(error);
        let err = '';
        let errShow = '';

        // Проверяем, является ли response.data ArrayBuffer (для file запросов)
        if (error.response?.data instanceof ArrayBuffer) {
            // Для ArrayBuffer пытаемся декодировать как текст
            try {
                const decoder = new TextDecoder('utf-8');
                const text = decoder.decode(error.response.data);
                const parsed = JSON.parse(text);
                err = parsed.message || parsed.name || 'Ошибка при скачивании файла';
            } catch (e) {
                err = 'Ошибка при скачивании файла';
            }
        } else {
            // Для обычных JSON ответов
            err = error.response?.data?.message || error.response?.message || error.message || 'Неизвестная ошибка';
        }

        try {
            err = JSON.parse(err);
            if (Object.keys(err).length) {
                Object.keys(err).forEach((errIndex) => {
                    errShow += err[errIndex] + '<br/>';
                })
            }
        } catch (e) {
            errShow = err;
        }

        toast(errShow, {
            dangerouslyHTMLString: true,
            autoClose: 5000,
            type: 'error'
        });
    }
}
